import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { colspan: "100%" }
const _hoisted_2 = { class: "flex flex-row-reverse items-center p-2" }
const _hoisted_3 = { class: "ml-8" }
const _hoisted_4 = { class: "flex items-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "mr-4" }, "Rows per page:", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_w_icon_button = _resolveComponent("w-icon-button")!
  const _component_w_selector = _resolveComponent("w-selector")!

  return (_openBlock(), _createElementBlock("tfoot", null, [
    _createElementVNode("tr", null, [
      _createElementVNode("td", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_w_icon_button, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:page', _ctx.page - 1))),
              disabled: _ctx.page == 0
            }, {
              default: _withCtx(() => [
                _createTextVNode(" chevron_left ")
              ]),
              _: 1
            }, 8, ["disabled"]),
            _createVNode(_component_w_icon_button, {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:page', _ctx.page + 1))),
              disabled: _ctx.toIndex == _ctx.count - 1
            }, {
              default: _withCtx(() => [
                _createTextVNode(" chevron_right ")
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode(_component_w_selector, {
              modelValue: _ctx.rows,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:rows', $event))),
              items: _ctx.rowsPerPageOptions,
              returnKey: "",
              itemKey: "value",
              itemText: "name",
              class: "mr-4 w-18"
            }, null, 8, ["modelValue", "items"]),
            _createElementVNode("span", null, _toDisplayString(_ctx.displayedItemsText), 1)
          ])
        ])
      ])
    ])
  ]))
}